<template>
	<div class="avue-top">
		<div class="top-bar__left">
			<div v-if="showCollapse" :class="[{'avue-breadcrumb--active': isCollapse}]" class="avue-breadcrumb">
				<i class="icon-navicon" @click="setCollapse" />
			</div>
		</div>
		<div class="top-bar__title">
			<div class="top-menu" style="display: inline-block; vertical-align: top">
				<el-button
					class="el-menu-item"
					icon="icon-shandian"
					plain
					style="border: none; height: 64px; background: inherit"
					@click="onShowWx(0)">
					快速理赔
				</el-button>
			</div>
			<div class="top-menu" style="display: inline-block; vertical-align: top">
				<el-button
					class="el-menu-item"
					icon="el-icon-eleme"
					plain
					style="border: none; height: 64px; background: inherit"
					@click="onShowWx(1)">
					手机投保
				</el-button>
			</div>
			<div v-if="showMenu" class="top-bar__item top-bar__item--show">
				<top-menu />
			</div>
		</div>
		<div class="top-bar__right">
			<!-- <el-tooltip
        v-if="showColor"
        effect="dark"
        content="主题色"
        placement="bottom">
        <div class="top-bar__item">
          <top-color/>
        </div>
      </el-tooltip> -->
			<el-tooltip
				v-if="showDebug"
				:content="logsFlag ? '没有错误日志' : `${logsLen}条错误日志`"
				effect="dark"
				placement="bottom">
				<div class="top-bar__item">
					<top-logs />
				</div>
			</el-tooltip>
			<el-tooltip v-if="showLock" content="锁屏" effect="dark" placement="bottom">
				<div class="top-bar__item">
					<top-lock />
				</div>
			</el-tooltip>
			<el-tooltip v-if="showTheme" content="特色主题" effect="dark" placement="bottom">
				<div class="top-bar__item top-bar__item--show">
					<top-theme />
				</div>
			</el-tooltip>
			<el-tooltip v-if="showFullScreen" :content="isFullScreen ? '退出全屏' : '全屏'" effect="dark" placement="bottom">
				<div class="top-bar__item">
					<i :class="isFullScreen ? 'icon-zuixiaohua' : 'icon-quanpingzuidahua'" @click="handleScreen" />
				</div>
			</el-tooltip>
			<el-tooltip v-if="userInfo.avatar" content="用户头像" effect="dark" placement="bottom">
				<img id="thumbnail" alt="" class="top-bar__img" src="" />
			</el-tooltip>
			<el-dropdown style="margin-left: 10px">
				<div class="u-flex u-row-center">
					<div class="u-flex-col u-col-center" style="margin-right: 5px">
						{{ userInfo ? userInfo.username : '未知' }}
						<div
							v-if="envConfig.isBxXsm() && userInfo && userInfo.distAccount"
							style="font-size: 12px; text-align: center">
							工号：{{ userInfo.distAccount.number }}
						</div>
					</div>
					<i class="el-icon-arrow-down el-icon&#45;&#45;right" />
				</div>
				<el-dropdown-menu slot="dropdown">
					<el-dropdown-item divided>
						<router-link to="/">首页</router-link>
					</el-dropdown-item>
					<el-dropdown-item divided v-if="userInfo && userInfo.userType != 'sys' && showYearEnd">
						<div @click="openMyNz">我的 2024</div>
					</el-dropdown-item>
					<!-- <el-dropdown-item
            divided
            @click.native="$refs.seting.open()">界面设置
          </el-dropdown-item> -->
					<el-dropdown-item v-if="permissions['createChannelByCode']" divided @click.native="generatedCode">
						生成邀请码
					</el-dropdown-item>

					<el-dropdown-item divided @click.native="logout">退出系统</el-dropdown-item>
				</el-dropdown-menu>
			</el-dropdown>
			<top-setting ref="seting" />
		</div>
		<div style="text-align: center; font-weight: 500">
			<el-dialog :title="getWxData.title" :visible.sync="dialogVisible" width="30%">
				<div>{{ getWxData.content }}</div>
				<div style="margin-top: 50px">
					<img :src="getWxData.imgUrl" alt="" style="height: 230px; padding: 10px; border: 1px solid #ddd" />
				</div>
			</el-dialog>
		</div>

		<!-- 展示二维码模态框 generatedCodeFlag codeUrl-->
		<el-dialog :visible.sync="generatedCodeFlag" append-to-body title="注册二维码">
			<div style="width: 100%; display: flex; justify-content: center">
				<img :src="codeUrl" alt="" style="width: 200px; height: 200px" />
			</div>
		</el-dialog>

		<el-dialog
			:close-on-click-modal="false"
			:close-on-press-escape="false"
			:show-close="false"
			:visible.sync="isShowNzzj"
			append-to-body
			class="year-report-dialog">
			<div class="year_report_main">
				<div
					class="close-icon"
					style="
						position: absolute;
						top: 12px;
						right: -42px;
						z-index: 99;
						font-size: 28px;
						color: #fff;
						cursor: pointer;
					">
					<i class="el-icon-close" @click="closeNzzj"></i>
				</div>
				<newYearReportModal></newYearReportModal>
			</div>
		</el-dialog>
	</div>
</template>
<script>
import {mapGetters, mapState} from 'vuex'
import {fullscreenToggel, handleImg, listenfullscreen} from '@/util/util'
import {channelReport, generatedContactCode} from '@/api/admin/user'
import {getStore, setStore} from '@/util/store'
import topLock from './top-lock'
import topMenu from './top-menu'
import topTheme from './top-theme'
import topLogs from './top-logs'
import store from '@/store'
import topColor from './top-color'
import topSetting from './top-setting'
import newYearReportModal from '@/components/ui/newYearReportModal.vue'
import sensors from 'sa-sdk-javascript'
export default {
	name: 'Top',
	components: {
		topLock,
		topMenu,
		topTheme,
		newYearReportModal,
		topLogs,
		topColor,
		topSetting,
	},
	filters: {},
	data() {
		return {
			generatedCodeFlag: false,
			codeUrl: '',
			showYearEnd: true,
			isShowNzzj: false,
			dialogVisible: false,
			currentIndex: 0,
			scanData: [
				{
					title: '快速理赔',
					content: '已为您开通快速理赔通道，微信扫一扫即可发起理赔！',
					imgUrl: 'images/xslp.png',
				},
				{
					title: '手机投保',
					content: '移动端手机投保，随时随地都能便捷投保',
					imgUrl: 'images/xslp_ie.jpg',
				},
			],
		}
	},
	computed: {
		...mapState({
			showDebug: (state) => state.common.showDebug,
			showTheme: (state) => state.common.showTheme,
			showLock: (state) => state.common.showLock,
			showFullScreen: (state) => state.common.showFullScreen,
			showCollapse: (state) => state.common.showCollapse,
			showMenu: (state) => state.common.showMenu,
			showColor: (state) => state.common.showColor,
		}),
		...mapGetters([
			'userInfo',
			'isFullScreen',
			'permissions',
			'tagWel',
			'tagList',
			'isCollapse',
			'tag',
			'logsLen',
			'logsFlag',
		]),
		getWxData() {
			return this.scanData[this.currentIndex]
		},
	},
	created() {
		if (this.envConfig.isBxIe()) {
			handleImg(this.userInfo.avatar, 'thumbnail')
		} else {
			//新市民小程序
			this.scanData[1].imgUrl = 'images/xslp_xsm.png'
		}
	},
	async mounted() {
		listenfullscreen(this.setScreen)
		//新市民不展示
		if (this.envConfig.isBxIe()) {
			//查询有没有数据 没有数据则不展示
			let reportRes = await channelReport()
			this.showYearEnd = !(reportRes.data.code !== 0 || !reportRes.data.data)
		}
	},
	methods: {
		async generatedCode() {
			let {code = -1, data = {}} = await generatedContactCode({
				appId: 'wx5c335eed0afec390',
				page: 'package-personal/pages/channelOpen',
				checkPath: false,
			})
			console.log('generatedCode', code, data)
			if (data.code == 0) {
				this.codeUrl = 'data:image/png;base64,' + data.data
				this.generatedCodeFlag = true
			}
		},
		closeNzzj() {
			sensors.track('ie_annual_report_popup_view_click', {button_name: '关闭'})
			this.isShowNzzj = false
		},
		//打开年终
		openMyNz() {
			sensors.track('ie_annual_report_popup_display', {})
			this.isShowNzzj = true
		},
		handleScreen() {
			fullscreenToggel()
		},
		setCollapse() {
			this.$store.commit('SET_COLLAPSE')
		},
		setScreen() {
			this.$store.commit('SET_FULLSCREEN')
		},
		logout() {
			this.$confirm('即将退出系统, 是否继续?', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning',
			}).then(() => {
				this.$store.dispatch('LogOut').then(() => {
					setStore({name: 'login', content: {forceRefresh: true}})
					this.$router.push({path: '/login'})
				})
			})
		},
		//0：快速理赔，1：Ie保小程序
		onShowWx(type) {
			this.currentIndex = type
			this.dialogVisible = true
		},
	},
}
</script>

<style lang="scss" scoped>
/deep/ .el-dialog__header {
	padding: 10px 20px 10px;
}

.news-dialog {
	::v-deep .el-dialog {
		background: transparent !important;
	}

	::v-deep .el-dialog__body {
		padding: 0 !important;
		border-radius: 12px !important;
	}

	::v-deep .el-dialog__header {
		display: none !important;
	}
}
</style>
